module.exports = __webpack_public_path__ + "images/fa-landing-testimonials-mobile.webp";